define(function (require, exports, module) {
    var isMaxFullWidth = $('.container--max-width');

    if (isMaxFullWidth && isMaxFullWidth[0]) {
        return;
    }
    var skinTotal = ~~($('body').attr('data-background-skin-total'));

    if (skinTotal) {
        var $main = $('main');
        var skinChoice = Math.floor(Math.random() * skinTotal) + 1;
        var skinClass = 'club-bg-skin club-bg-skin--' + skinChoice;

        $main.addClass(skinClass);
    }
});
